import React from "react";
import ReactDOM from "react-dom/client";
import "@/theme/tokens.css";
import { applySkin } from "@/theme/skin";
import { applyGridLook, readGridLook } from "@/theme/gridLook";
import "@/index.css";
import App from "@/App";

applySkin();
applyGridLook(readGridLook(), { remember: false });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
